"use strict";

var _document$querySelect;
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly &&
      (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })),
      keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2
      ? ownKeys(Object(source), !0).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        })
      : Object.getOwnPropertyDescriptors
      ? Object.defineProperties(
          target,
          Object.getOwnPropertyDescriptors(source)
        )
      : ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(
            target,
            key,
            Object.getOwnPropertyDescriptor(source, key)
          );
        });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true,
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function setVh() {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", "".concat(vh, "px"));
}
window.addEventListener("resize", setVh);
setVh();
var siblings = function (el) {
  if (el.parentNode === null) return [];
  return Array.prototype.filter.call(el.parentNode.children, function (child) {
    return child !== el;
  });
};
function setCookie(c_name, value, exdays) {
  var c_value = escape(value);
  if (exdays) {
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + exdays);
    c_value += "; expires=" + exdate.toUTCString();
  }
  document.cookie = c_name + "=" + c_value;
}
function getCookie(c_name) {
  var i,
    x,
    y,
    cookies = document.cookie.split(";");
  for (i = 0; i < cookies.length; i++) {
    x = cookies[i].substr(0, cookies[i].indexOf("="));
    y = cookies[i].substr(cookies[i].indexOf("=") + 1);
    x = x.replace(/^\s+|\s+$/g, "");
    if (x === c_name) {
      return unescape(y);
    }
  }
}
const heroAlt = document.querySelector(".hero-alt");
const imageText = document.querySelector(".section-image-text");
let isFirst = false;
if (
  heroAlt &&
  !(
    heroAlt !== null &&
    heroAlt !== void 0 &&
    heroAlt.closest(".shopify-section").previousElementSibling
  )
) {
  isFirst = heroAlt;
} else if (
  imageText &&
  !(
    imageText !== null &&
    imageText !== void 0 &&
    imageText.closest(".shopify-section").previousElementSibling
  )
) {
  isFirst = imageText;
}
// Announcement bar (supports both default + women section ids)
document.querySelectorAll(".announcement-bar-close").forEach((btn) => {
  btn.addEventListener("click", function () {
    var _section;
    const section =
      this.closest("#shopify-section-announcement-bar") ||
      this.closest("#shopify-section-announcement-bar-women") ||
      this.closest('[id^="shopify-section-announcement-bar"]');
    (_section = section) === null || _section === void 0
      ? void 0
      : _section.classList.add("is-closed");

    // Backward-compatible key for the default section; scoped key for other variants.
    const storageKey =
      section && section.id === "shopify-section-announcement-bar"
        ? "bar"
        : "bar:".concat(section ? section.id : "unknown");
    sessionStorage.setItem(storageKey, "true");

    const headerHeight = document.querySelector("header").offsetHeight;
    if (headerHeight && isFirst) {
      isFirst.style.marginTop = "-".concat(headerHeight, "px");
    }
    setMainMinHeight();
    window.dispatchEvent(new CustomEvent("custom:ann-bar-closed"));
  });
});
const bodyEl = document.querySelector("body");
const loader = document.querySelector(".loader");
const productWeek = document.querySelector(".product-default--week");
function sliderProducts() {
  const sliders = document.querySelectorAll(".slider-products");
  if (sliders == null) {
    return;
  }
  const swipers = [];
  sliders.forEach((el) => {
    const id = el
      .closest(".shopify-section")
      .id.replace("shopify-section-", "");
    const slider = el.querySelector(".swiper");
    const gridOnMobile = slider.classList.contains("--grid-on-mobile");
    const prev = el.querySelector(".slider-btn--prev");
    const next = el.querySelector(".slider-btn--next");
    const slidesPerView = Number(el.dataset.slides);
    const blocksSize = Number(el.dataset.blocksSize);
    const loop = blocksSize > slidesPerView;
    let centeredSlides = false;
    let initialSlide = 0;
    const options = {
      speed: 400,
      slidesPerView: "auto",
      centeredSlides: true,
      initialSlide: 1,
      navigation: {
        prevEl: prev,
        nextEl: next,
      },
      loop: loop,
      breakpoints: {
        768: {
          slidesPerView,
          centeredSlides,
          initialSlide,
        },
      },
    };
    let swiper =
      window.innerWidth > 768
        ? new Swiper(slider, options)
        : gridOnMobile
        ? null
        : new Swiper(slider, options);
    if (gridOnMobile) {
      window.addEventListener("resize", () => {
        if (window.innerWidth <= 768) {
          var _swiper;
          (_swiper = swiper) === null || _swiper === void 0
            ? void 0
            : _swiper.destroy(true, true);
        } else if (window.innerWidth > 768 && (!swiper || swiper.destroyed)) {
          swiper = new Swiper(slider, options);
        }
      });
    }
    swipers.push({
      id,
      options,
    });
  });
  window.addEventListener("shopify:section:load", (e) => {
    const swiperObj = swipers.find((obj) => obj.id === e.detail.sectionId);
    if (swiperObj) {
      const slider = document.querySelector(
        "#shopify-section-".concat(swiperObj.id, " .swiper")
      );
      const gridOnMobile = slider.classList.contains("--grid-on-mobile");
      const parent = slider.closest(".slider-products");
      const perView = Number(parent.dataset.slides);
      const blocks = Number(parent.dataset.blocksSize);
      const newOptions = _objectSpread(
        _objectSpread({}, swiperObj.options),
        {},
        {
          loop: blocks > perView,
        }
      );
      let swiper =
        window.innerWidth > 768
          ? new Swiper(slider, newOptions)
          : gridOnMobile
          ? null
          : new Swiper(slider, newOptions);
      if (gridOnMobile) {
        window.addEventListener("resize", () => {
          if (window.innerWidth <= 768) {
            var _swiper2;
            (_swiper2 = swiper) === null || _swiper2 === void 0
              ? void 0
              : _swiper2.destroy(true, true);
          } else if (window.innerWidth > 768 && (!swiper || swiper.destroyed)) {
            swiper = new Swiper(slider, newOptions);
          }
        });
      }
    }
  });
}
function sliderRecommends() {
  const sliders = document.querySelectorAll(".slider-recommendations");
  if (sliders == null) {
    return;
  }
  sliders.forEach((el) => {
    const slider = el.querySelector(".swiper");
    const swiper = new Swiper(slider, {
      speed: 400,
      slidesPerView: 1,
      loop: true,
      centeredSlides: true,
      breakpoints: {
        768: {
          initialSlide: 2,
        },
      },
    });
  });
}
setTimeout(function () {
  sliderRecommends();
}, 1500);
window.addEventListener("load", sliderProducts);
const navTrigger = document.querySelector(".js-nav-trigger");
const navClose = document.querySelector(".js-nav-close");
const nav = document.querySelector(".nav");
const bodyIsHidden = document.querySelector("body").style.overflow === "hidden";
navTrigger.addEventListener("click", function () {
  var _document$querySelect2;
  (_document$querySelect2 = document.querySelector(
    ".k_newsletter_modal.--general .nl_popup_close"
  )) === null || _document$querySelect2 === void 0
    ? void 0
    : _document$querySelect2.click();
  nav.classList.add("is-open");
  if (!bodyIsHidden) {
    document.querySelector("body").style.overflow = "hidden";
    document.documentElement.style.overflow = "hidden";
    document.querySelector("body").style.position = "relative";
    document.querySelector("body").style.height = "100%";
  }
});
navClose.addEventListener("click", function () {
  nav.classList.remove("is-open");
  if (!bodyIsHidden) {
    document.documentElement.style.removeProperty("overflow");
    document.querySelector("body").style.removeProperty("overflow");
    document.querySelector("body").style.removeProperty("position");
    document.querySelector("body").style.removeProperty("height");
  }
});
const headerContainer = document.querySelector(".header-container");
let oldValue = 0;
let newValue = 0;
window.addEventListener("scroll", (e) => {
  newValue = window.pageYOffset;
  if (oldValue < newValue) {
    headerContainer.classList.add("is-scrolled");
  } else if (oldValue > newValue) {
    headerContainer.classList.remove("is-scrolled");
  }
  oldValue = newValue;
});

// Handle COLLECTIONS

const collections = document.querySelectorAll(".js-collections ul a");
const collectionHandles = [];
collections.forEach((item) => {
  const collHandle = item.dataset.handle;
  collectionHandles.push(collHandle);
});
const graphqlQuery = (handle, cursor, productsLength) => {
  let myCursor = "";
  if (cursor != "") {
    myCursor = ', after: "'.concat(cursor, '"');
  }
  return {
    method: "POST",
    headers: {
      "X-Shopify-Storefront-Access-Token": "b2837c6973245ee6adcc6958a1cf25ad",
      "Content-Type": "application/graphql",
    },
    body: 'query findProducts {\n      collection(handle: "'
      .concat(
        handle,
        '") {\n        title,\n        descriptionHtml,\n          products(first: 15 '
      )
      .concat(
        myCursor,
        ") {\n            edges {\n              cursor,\n              node {\n                handle,\n                title,\n                tags,\n                images(first: 1) {\n                  edges {\n                    node {\n                      url(transform: {maxWidth: 700})\n                    }\n                  }\n                },\n                options {\n                  values,\n                  name\n                },\n                variants(first: 15) {\n                  edges {\n                    node {\n                      title,\n                      id\n                    }\n                  }\n                },\n                priceRange {\n                  minVariantPrice {\n                    amount,\n                    currencyCode\n                  }\n                }\n              }\n            },\n            pageInfo {\n              hasNextPage,\n              hasPreviousPage,\n              endCursor\n            }\n          }\n        }\n    }"
      ),
  };
};
let cursor = "";
let productsLength = 14;
let flag = true;
const addGraphQlProducts = (collectionHandle) => {
  fetch(
    "//".concat(window.location.host, "/api/2022-04/graphql.json"),
    graphqlQuery(collectionHandle, cursor, productsLength)
  )
    .then((res) => {
      return res.json();
    })
    .then((data) => {
      const collection = data.data.collection;
      const products = collection.products;
      const nextPage = products.pageInfo.hasNextPage;
      const prevPage = products.pageInfo.hasPreviousPage;
      const lastCursor = products.pageInfo.endCursor;
      const initialCursor = products.edges[0].cursor;
      const collectionDescription = collection.descriptionHtml;
      const collectionTitle = collection.title;
      const collectionTitleHandle = collectionTitle
        .toLowerCase()
        .replace(" ", "-");
      const collectionBody = document.querySelector(".js-collection-items");
      if (flag) {
        cursor = lastCursor;
        const collectionTitleH2 = document.createElement("h2");
        const productsHolderDiv = document.createElement("div");
        collectionTitleH2.classList.add("collection__title");
        productsHolderDiv.classList.add("collection__grid");
        if (collectionDescription == "") {
          productsHolderDiv.classList.add("has-no-description");
        }
        collectionTitleH2.textContent = collectionTitle;
        productsHolderDiv.setAttribute(
          "data-collection",
          collectionTitleHandle
        );
        collectionBody.appendChild(collectionTitleH2);
        collectionBody.appendChild(productsHolderDiv);
      }
      flag = false;
      if (nextPage) {
        cursor = lastCursor;
        if (prevPage == false) {
          const collectionTitleH2 = document.createElement("h2");
          const productsHolderDiv = document.createElement("div");
          collectionTitleH2.classList.add("collection__title");
          productsHolderDiv.classList.add("collection__grid");
          if (collectionDescription == "") {
            productsHolderDiv.classList.add("has-no-description");
          }
          collectionTitleH2.textContent = collectionTitle;
          productsHolderDiv.setAttribute(
            "data-collection",
            collectionTitleHandle
          );
          collectionBody.appendChild(collectionTitleH2);
          collectionBody.appendChild(productsHolderDiv);
        }
      } else {
        if (prevPage == false) {
          const collectionTitleH2 = document.createElement("h2");
          const productsHolderDiv = document.createElement("div");
          collectionTitleH2.classList.add("collection__title");
          productsHolderDiv.classList.add("collection__grid");
          if (collectionDescription == "") {
            productsHolderDiv.classList.add("has-no-description");
          }
          collectionTitleH2.textContent = collectionTitle;
          productsHolderDiv.setAttribute(
            "data-collection",
            collectionTitleHandle
          );
          collectionBody.appendChild(collectionTitleH2);
          collectionBody.appendChild(productsHolderDiv);
        }
        cursor = "";
        if (handleIndex < collectionHandles.length - 1) {
          handleIndex++;
        } else {
          handleIndex = 0;
        }
      }
      products.edges.forEach((item, index) => {
        const myProductItemDescription =
          '\n          <div class="collection__grid-item">\n            <div class="product-item-description">\n              '.concat(
            collectionDescription,
            "\n            </div>\n          </div>\n        "
          );
        const myProductItem =
          '\n          <div class="collection__grid-item">\n            <div class="product-item">\n              <div class="product__image">\n                <div\n                class="product__image-inner"\n                >\n                  <img src="'
            .concat(
              item.node.images.edges[0].node.url,
              '" loading="lazy" alt="img">\n                </div>\n                <a href="/products/'
            )
            .concat(
              item.node.handle,
              '"></a>\n\n\n              </div>\n              <div class="product__content">\n                <div class="product__head">\n                  <h4 class="product__title">\n                    <a href="/products/'
            )
            .concat(item.node.handle, '">\n                      ')
            .concat(
              item.node.title,
              '\n                    </a>\n                  </h4>\n\n                  <div class="product__price">\n                    <span>'
            )
            .concat(
              item.node.priceRange.minVariantPrice.amount.replace(".0", ""),
              " "
            )
            .concat(
              item.node.priceRange.minVariantPrice.currencyCode,
              "</span>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        "
            );
        if (prevPage == false && index == 4) {
          document.querySelector(
            ".collection__body .collection__grid:last-of-type"
          ).innerHTML =
            document.querySelector(
              ".collection__body .collection__grid:last-of-type"
            ).innerHTML + myProductItemDescription;
        }
        document.querySelector(
          ".collection__body .collection__grid:last-of-type"
        ).innerHTML =
          document.querySelector(
            ".collection__body .collection__grid:last-of-type"
          ).innerHTML + myProductItem;
      });
      loader.classList.remove("is-loading");
    });
};
let handleIndex = 0;
if (document.querySelector(".collection-default--special") != null) {
  addGraphQlProducts(collectionHandles[handleIndex]);
  let scrollTimer = -1;
  window.addEventListener("scroll", function () {
    let scroll = window.pageYOffset;
    const winHeight = window.innerHeight;
    const docHeight = document.body.clientHeight;
    let scrollBottom = scroll + winHeight;
    if (scrollTimer != -1) {
      clearTimeout(scrollTimer);
    }
    scrollTimer = window.setTimeout(function () {
      if (scrollBottom >= docHeight - 100) {
        loader.classList.add("is-loading");
        addGraphQlProducts(collectionHandles[handleIndex]);
      }
    }, 500);
  });
}
document.querySelectorAll(".filter-grid .filter__btn").forEach((btn) => {
  btn.addEventListener("click", function (event) {
    let collectionDefault = document.querySelector(".collection-default");
    event.preventDefault();
    const viewBy = this.dataset.filterBy;
    this.classList.add("is-active");
    siblings(this).forEach((sibling) => {
      sibling.classList.remove("is-active");
    });
    collectionDefault.classList.remove(
      "view-by-two",
      "view-by-four",
      "view-thumb-grid"
    );
    collectionDefault.classList.add(viewBy);
    if (window.scrollY > 0) {
      window.scrollTo({ top: 0 });
    } else {
      const event = new CustomEvent("custom:products-fade-in");
      window.dispatchEvent(event);
    }
  });
});

// AJAX ADD TO CART

window.addEventListener("custom:open-drawer", () => {
  openCartDrawer();
  createCart();
  getCart();
});
const drawerBody = document.querySelector(".js-cart-drawer-items");
const linkCartDrawer = document.querySelectorAll(".header__cart-icon");
const cartDrawerClose = document.querySelector(".cart-drawer .cart__close");
const cartDrawerBG = document.querySelector(".cart-drawer .cart__background");
const cartDrawer = document.querySelector(".cart-drawer");
const cartOutside = document.querySelector(".cart__outside");
const cartDrawerError = document.querySelector(".cart-drawer .cart__error");
const cartDrawerNote = document.querySelector("#cart-note--drawer-note");

function openCartDrawer() {
  cartDrawer.classList.add("is-open");
  cartOutside.classList.add("is-open")
  bodyEl.classList.add("is-stopped");
}
function closeCartDrawer() {
  cartDrawer.classList.remove("is-open");
  cartOutside.classList.remove("is-open")
  bodyEl.classList.remove("is-stopped");
}
function createCart() {
  fetch("/cart?view=ajax", {
    headers: {
      "Content-Type": "application/json",
    },
    method: "GET",
  })
    .then((response) => {
      return response.text();
    })
    .then((myData) => {
      const html = new DOMParser()
        .parseFromString(myData, "text/html")
        .querySelector(".cart__items").innerHTML;
      drawerBody.innerHTML = html;
    });
}
createCart();

function formatCartTotal(totalPriceInCents, currencyCode) {
  const locale = document.documentElement.lang || navigator.language || "en";

  try {
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency: currencyCode,
    }).format(totalPriceInCents / 100);
  } catch (error) {
    return "".concat((totalPriceInCents / 100).toFixed(2), " ").concat(currencyCode || "");
  }
}

function getCart() {
  fetch("/cart.js", {
    headers: {
      "Content-Type": "application/json",
    },
    method: "GET",
  })
    .then((res) => {
      return res.json();
    })
    .then((data) => {
      const itemsCount = data.item_count;
      const formattedTotalAmount = formatCartTotal(data.total_price, data.currency);

      if (cartDrawerNote) {
        cartDrawerNote.value = data.note || "";
      }

      linkCartDrawer.forEach((link) => {
        link.setAttribute("data-items-count", "".concat(itemsCount));
      });
      document.querySelectorAll(".cart-count-bubble > span").forEach((text) => {
        text.textContent = itemsCount;
      });
      document.querySelector(".cart-drawer .cart__counter").textContent =
        "(".concat(itemsCount, ")");
      const cartTotalAmount = document.querySelector(".js-total-amount");
      if (cartTotalAmount) {
        cartTotalAmount.textContent = formattedTotalAmount;
      }
    });
}
const btnAdd = document.querySelector(".js-ajax-add");
if (btnAdd != null && productWeek == null) {
  document
    .querySelector(".js-ajax-add")
    .addEventListener("click", function (e) {
      e.preventDefault();
      let quantity = 1;
      if (document.querySelector(".js-quantity-input") != null) {
        quantity = document.querySelector(".js-quantity-input").value;
      }
      const id = document.querySelector(".js-value-input").value;
      const config = {
        items: [
          {
            id,
            quantity,
          },
        ],
      };
      fetch("/cart/add.js", {
        headers: {
          "Content-Type": "application/json",
        },
        method: "POST",
        body: JSON.stringify(config),
      })
        .then((res) => {
          return res.json();
        })
        .then((data) => {
          if (data.description) {
            const nextEl = this.nextElementSibling;
            nextEl.textContent = data.description;
            nextEl.classList.add("is-active");
          } else {
            createCart();
            openCartDrawer();
            setTimeout(function () {
              getCart();
            }, 500);
          }
        });
    });
}
linkCartDrawer.forEach((link) => {
  link.addEventListener("click", function (event) {
    const count = Number(link.getAttribute("data-items-count"));
    if (count !== 0) {
      event.preventDefault();
      openCartDrawer();
      createCart();
      getCart();
    }
  });
});
function closeErrors() {
  document.querySelectorAll(".item-cart .item__error").forEach((errorField) => {
    errorField.classList.remove("is-active");
  });
}
cartDrawerClose.addEventListener("click", function () {
  event.preventDefault();
  closeCartDrawer();
  closeErrors();
});
cartDrawerBG.addEventListener("click", function () {
  event.preventDefault();
  closeCartDrawer();
  closeErrors();
});
function updateCart(id, quantity) {
  let updates = {};
  updates[id] = quantity;
  fetch("/cart/update.js", {
    headers: {
      "Content-Type": "application/json",
    },
    method: "POST",
    body: JSON.stringify({
      updates,
    }),
  })
    .then((res) => {
      return res.json();
    })
    .then((data) => {
      createCart();
    });
}
$(".cart-drawer").on("click", ".qty__plus", function (event) {
  event.preventDefault();
  const $this = $(this);
  let currentValue = $this.prev().val();
  currentValue++;
  const itemId = $this.parents(".item-cart").data("id");
  const inventoryQuantity = $this.parents(".item-cart").data("max-quantity");
  const errorField = $this.parents(".item-cart").find(".item__error");
  if (currentValue <= inventoryQuantity) {
    $this.prev().val(currentValue);
    updateCart(itemId, currentValue);
    setTimeout(function () {
      getCart();
    }, 500);
  } else {
    errorField.addClass("is-active");
  }
});
$(".cart-drawer").on("click", ".qty__minus", function (event) {
  event.preventDefault();
  const $this = $(this);
  const itemId = $this.parents(".item-cart").data("id");
  let currentValue = $this.next().val();
  if (currentValue > 0) {
    currentValue--;
    $this.next().val(currentValue);
    updateCart(itemId, currentValue);
    setTimeout(function () {
      getCart();
    }, 500);
  }
});
function imagesOnScroll() {
  const images = document.querySelectorAll(
    ".section-text-over-images .section__image"
  );
  if (images == null) {
    return;
  }
  window.addEventListener("scroll", function () {
    const scroll = window.pageYOffset;
    const halfScreen = window.innerHeight / 2;
    const midLane = scroll + halfScreen - 100;
    images.forEach((image, index) => {
      const imageOffsetTop = image.offsetTop;
      const imageOffsetBottom = imageOffsetTop + image.offsetHeight;
      const imageTop = imageOffsetTop - 100;
      const imageBottom = imageOffsetBottom + 100;
      if (midLane >= imageTop && midLane <= imageBottom) {
        image.classList.add("in-view");
      } else {
        image.classList.remove("in-view");
      }
    });
  });
}
imagesOnScroll();
document.querySelectorAll(".accordion-default").forEach((accordion) => {
  const accordionTrigger = accordion.querySelector(".accordion__head");
  accordionTrigger.addEventListener("click", function () {
    const parent = this.parentNode;
    const isOpen = parent.classList.contains("is-open");
    parent.classList.toggle("is-open");
    const body = parent.querySelector(".accordion__body");
    if (isOpen) {
      body.style.height = "0px";
    } else {
      body.style.height = "".concat(body.scrollHeight, "px");
    }
    siblings(parent).forEach((sibling) => {
      sibling.classList.remove("is-open");
      const body = sibling.querySelector(".accordion__body");
      body.style.height = "0px";
    });
  });
});
function variantsToStrings(item) {
  let variantsString = "";
  item.querySelectorAll(".is-selected").forEach((radio) => {
    const selectedVal = radio.querySelector("input").value;
    variantsString += "-" + selectedVal;
  });
  return variantsString.substr(1);
}
const productItems = document.querySelectorAll(".item-product-simple");
const productItemsPack = document.querySelectorAll(
  ".item-pack-product-additional"
);
function createNavLinks() {
  const $nav = $(".js-list-info");
  if ($nav.length == 0) {
    return;
  }
  const listHeadings = document.querySelectorAll(".js-list-content h2");
  listHeadings.forEach((heading, index) => {
    const headingHandle = heading.textContent
      .toLowerCase()
      .replaceAll(" ", "-");
    const listItem = '<li data-handle="'
      .concat(headingHandle, "-")
      .concat(index + 1, '" ')
      .concat(
        heading.dataset.newGroup ? 'class="--new-group"' : "",
        '>\n      <a href="#'
      )
      .concat(headingHandle, "-")
      .concat(index + 1, '">')
      .concat(heading.textContent, "</a>\n    </li>");
    $nav.append(listItem);
  });
  $(document).on("click", ".js-list-info a", function (event) {
    event.preventDefault();
    const $this = $(this);
    const target = $this.attr("href");
    const list_top = document
      .querySelector(".js-list-info")
      .getBoundingClientRect().top;
    const el = document.querySelector(target);
    const el_top = el.getBoundingClientRect().top;
    const padding_top = window
      .getComputedStyle(el)
      .getPropertyValue("padding-top")
      .split("px")[0];
    const hasHash = $this.attr("data-has-hash");
    const conf = {
      top: el_top + Number(padding_top) - list_top,
    };
    conf.behavior = "smooth";
    window.scrollBy(conf);
    $this.removeAttr("data-has-hash");
  });
}
createNavLinks();
function initNavLinksSpy() {
  window.scrollTo({
    top: 0,
  });
  const sections = document.querySelectorAll("[data-section-handle]");
  if (sections.length == 0) {
    return;
  }
  const firstSection = sections[0];
  const firstSectionoffsetTop = firstSection.offsetTop;
  const firstNavItem = document.querySelector("[data-handle]:first-child");
  firstNavItem.classList.add("in-view");
  let scrollTimeOut = null;
  let scrollEffect = true;
  let activeNav = null;
  sections.forEach((section, idx) => {
    const offsetTop = section.offsetTop;
    const offsetBottom = offsetTop + section.offsetHeight;
    const sectionHandle = section.dataset.sectionHandle;
    const navItem = document.querySelector(
      '[data-handle="'.concat(sectionHandle, '"]')
    );
    if (idx === 0) activeNav = navItem;
    navItem.addEventListener("click", () => {
      if (activeNav) activeNav.classList.remove("in-view");
      navItem.classList.add("in-view");
      activeNav = navItem;
      scrollEffect = false;
    });
    window.addEventListener("scroll", () => {
      const scroll = window.pageYOffset;
      if (!scrollEffect) {
        clearTimeout(scrollTimeOut);
        scrollTimeOut = setTimeout(() => {
          scrollEffect = true;
        }, 300);
        return;
      }
      if (scroll <= firstSectionoffsetTop) {
        firstNavItem.classList.add("in-view");
        activeNav = firstNavItem;
      } else {
        if (scroll > offsetTop && scroll < offsetBottom) {
          navItem.classList.add("in-view");
          activeNav = navItem;
        } else {
          navItem.classList.remove("in-view");
        }
      }
    });
  });
}
initNavLinksSpy();
function initStickySidebar() {
  let scroll;
  let stickyContainer;
  let stickyContainerHeight;
  let stickyContainerOffsetTop;
  let stickyContainerOffsetLeft;
  let stickyElement;
  let stickyElementWidth;
  let stickyElementHeight;
  let scrollBottomCondition;

  // let initial_top = 0;

  function initialParameters() {
    stickyContainer = document.querySelector(".js-sticky-container");
    stickyContainerHeight = stickyContainer.offsetHeight;
    stickyContainerOffsetTop = stickyContainer.offsetTop;
    stickyContainerOffsetLeft = stickyContainer.offsetLeft;
    stickyElement = document.querySelector(".js-sticky-element");
    stickyElementWidth = stickyElement.offsetWidth;
    stickyElementHeight = stickyElement.offsetHeight;
    scrollBottomCondition =
      stickyContainerOffsetTop + stickyContainerHeight - stickyElementHeight;
  }
  function onScrollActions() {
    if (!stickyElement) return;
    (stickyElement.style.position = "sticky"),
      (stickyElement.style.top = "".concat(
        document.querySelector("header.header").getBoundingClientRect().bottom,
        "px"
      ));
    if (stickyContainer) {
      const header = document.querySelector("header.header");
      const hasClass = header.classList.contains("--large-bp");
      const bottom = stickyContainer.getBoundingClientRect().bottom;
      if (bottom < 0 && hasClass) {
        document.querySelector("header.header").classList.remove("--large-bp");
      } else if (bottom >= 0 && !hasClass) {
        document.querySelector("header.header").classList.add("--large-bp");
      }
    }
  }
  window.addEventListener("load", () => {
    initialParameters();
    onScrollActions();
  });
  window.addEventListener("resize", () => {
    initialParameters();
    onScrollActions();
  });
  window.addEventListener("scroll", onScrollActions);
  const resizeObserver = new ResizeObserver(onScrollActions);
  resizeObserver.observe(document.body);
}
function goToHash(screen) {
  if (location.hash) {
    if (!location.hash.slice(1)) return;
    setTimeout(() => {
      if (screen === "desktop") {
        const el = document.querySelector(
          "a[href*=".concat(location.hash.slice(1), "]")
        );
        el.setAttribute("data-has-hash", true);
        location.hash = "";
        el.click();
      } else {
        var _document$querySelect3;
        const el = document.querySelector(
          "[id*=".concat(location.hash.slice(1), "]")
        );
        const headerBottom =
          (_document$querySelect3 = document.querySelector("header.header")) ===
            null || _document$querySelect3 === void 0
            ? void 0
            : _document$querySelect3.getBoundingClientRect().bottom;
        const topDist = el.getBoundingClientRect().top - headerBottom;
        window.scrollBy({
          top: topDist,
        });
      }
    }, 400);
  }
}
function watchHashChange() {
  if (window.innerWidth > 768) {
    initStickySidebar();
    goToHash("desktop");
  } else {
    goToHash("mobile");
  }
}
if (document.querySelector(".js-sticky-container") !== null) {
  window.addEventListener("hashchange", watchHashChange);
  watchHashChange();
}
document.querySelectorAll(".js-check-checkout").forEach((el) => {
  const input = el.querySelector("input");
  input.addEventListener("change", function () {
    if (input.checked) {
      el.classList.add("is-checked");
    } else {
      el.classList.remove("is-checked");
    }
  });
});
const filtersContainer = document.querySelector(".collection__filters");
if (document.querySelector(".collection__filters") != null) {
  document
    .querySelector(".js-show-filters")
    .addEventListener("click", function () {
      filtersContainer.classList.add("is-active");
    });
  document
    .querySelector(".js-filter-mobile")
    .addEventListener("click", function () {
      filtersContainer.classList.add("is-active");
    });
  filtersContainer
    .querySelectorAll(".collection__filters-close")
    .forEach((close) => {
      close.addEventListener("click", function () {
        filtersContainer.classList.remove("is-active");
      });
    });
}
document
  .querySelectorAll('[data-radio-name="design"] input')
  .forEach((radio) => {
    radio.addEventListener("change", function () {
      const value = radio.value;
    });
  });
let options_length;
const hiddenInput = document.querySelector(".options-sizes");
if (hiddenInput != null) {
  options_length = hiddenInput.value;
}
let myOptions = {};
const colors = document.querySelectorAll(".product-color");
const checkQty = (element) => {
  const action = element.data("action");
  let inputValue = 0;
  if (action == "minus") {
    inputValue = element.next().val(currentValue);
  } else if (action == "plus") {
    inputValue = element.prev().val(currentValue);
  }
  if (inputValue > 0) {
    element.closest(".radio-color").addClass("is-selected");
  } else {
    element.closest(".radio-color").removeClass("is-selected");
  }
};
function setPrice() {
  const $master = $(".js-main-master-select");
  const $choosenOption = $master.find("option:selected");
  const $price = $choosenOption.data("price");
  $(".js-price-container").html($price);
}
const currentPage = window.location.pathname;
if (document.querySelector(".js-filters") != null) {
  const filters = document.querySelectorAll(".js-filters .filter");
  let buildUrl = "";
  let finalUrl = "";
  function createFilterURL() {
    filters.forEach((el) => {
      let params = "";
      const filterName = el.dataset.name;
      const inputs = el.querySelectorAll("input");
      inputs.forEach((input) => {
        inputValue = input.value;
        if (input.checked) {
          params = params + inputValue + ",";
        }
      });
      buildUrl = ""
        .concat(buildUrl, "filter.v.option.")
        .concat(filterName, "=")
        .concat(params, "&");
    });
  }
  const destination = document.querySelector(
    ".collection-default .collection__body"
  );
  document.querySelectorAll(".js-filters input").forEach((item) => {
    item.addEventListener("change", function () {
      buildUrl = "";
      finalUrl = "";
      createFilterURL();
      finalUrl = "".concat(currentPage, "?").concat(buildUrl);
      fetch(finalUrl)
        .then((res) => res.text())
        .then((data) => {
          const html = new DOMParser().parseFromString(data, "text/html");
          const source = html.querySelector(".collection__body");
          destination.innerHTML = source.innerHTML;
        });
    });
  });
}
const provinceEl = document.querySelector(".form__province");
if (document.querySelectorAll(".js-popup-trigger").length > 0) {
  document.querySelectorAll(".js-popup-trigger").forEach((btnTrigger) => {
    btnTrigger.addEventListener("click", function (e) {
      e.preventDefault();
      const target = this.dataset.target;
      document.querySelector(target).classList.add("is-active");
    });
  });
}
if (document.querySelectorAll(".js-popup-close").length > 0) {
  document.querySelectorAll(".js-popup-close").forEach((btnClose) => {
    btnClose.addEventListener("click", function () {
      const target = this.closest(".js-popup");
      target.classList.remove("is-active");
    });
  });
}
const annBar =
  document.querySelector("#shopify-section-announcement-bar") ||
  document.querySelector("#shopify-section-announcement-bar-women");
if (annBar) {
  const storageKey =
    annBar.id === "shopify-section-announcement-bar"
      ? "bar"
      : "bar:".concat(annBar.id);
  let announcementBarSession =
    sessionStorage.getItem(storageKey) || sessionStorage.getItem("bar");

  if (announcementBarSession == null) {
    if (isFirst) {
      const headerHeight = document.querySelector("header").offsetHeight;
      isFirst.style.marginTop = "-".concat(
        headerHeight + annBar.offsetHeight,
        "px"
      );
    }
    setMainMinHeight();
  } else {
    annBar.classList.add("is-closed");
    if (isFirst) {
      const headerHeight = document.querySelector("header").offsetHeight;
      isFirst.style.marginTop = "-".concat(headerHeight, "px");
      setMainMinHeight();
    }
  }
}
const navElement = document.querySelector("nav");
const closeBtn = document.querySelector(".js-nav-close");
if (nav && closeBtn) {
  nav.querySelectorAll("a").forEach((a) => {
    a.addEventListener("click", () => {
      if (window.innerWidth <= 768) closeBtn.click();
    });
  });
}
const navDefault = document.querySelector(".nav-default");
if (navDefault != null) {
}
if (window.innerWidth < 768) {
  document
    .querySelectorAll('.radio-color input[type="radio"]')
    .forEach((radio) => {
      radio.addEventListener("change", function () {
        executeBtnLabel();
        buttonLabel();
      });
    });
}
const headerSale = document.querySelector(".header--sale");
if (headerSale != null) {
  const currentLink = document.querySelector(".nav-default li.is-active");
  const activeParrent = currentLink.closest("li.has-dropdown");
  activeParrent.classList.add("is-open");
  activeParrent.classList.add("is-activated");
}
const searchDefault = document.querySelector(".search-default");
if (searchDefault != null) {
  let searchTrigger = document.querySelector(".link-search");
  const field = searchDefault.querySelector(".search__field");
  if (searchTrigger) {
    searchTrigger.addEventListener("click", function (e) {
      e.preventDefault();
      this.classList.toggle("is-open");
      searchDefault.classList.toggle("is-open");
      headerContainer.classList.toggle("has-active-search");
      if (
        (searchDefault === null || searchDefault === void 0
          ? void 0
          : searchDefault.getAttribute("data-prevent-hiding")) !== "true"
      )
        field.value = "";
      setTimeout(() => {
        if (searchDefault.classList.contains("is-open")) {
          field.focus();
        }
      }, 100);
    });
  }
  if (
    (searchDefault === null || searchDefault === void 0
      ? void 0
      : searchDefault.getAttribute("data-prevent-hiding")) !== "true"
  ) {
    window.addEventListener("click", (e) => {
      var _searchTrigger;
      if (!searchTrigger)
        searchTrigger = document.querySelector(".link-search");
      const t = e.target;
      if (
        searchTrigger &&
        (t === searchTrigger ||
          ((_searchTrigger = searchTrigger) !== null &&
            _searchTrigger !== void 0 &&
            _searchTrigger.contains(t)))
      )
        return;
      if (t !== field && !field.contains(e.target)) {
        var _searchTrigger2;
        searchDefault.classList.remove("is-open");
        (_searchTrigger2 = searchTrigger) === null || _searchTrigger2 === void 0
          ? void 0
          : _searchTrigger2.classList.remove("is-open");
      }
    });
  }
}
let observer = null;
function removeLoadingClasses() {
  document.querySelectorAll(".--img-loading").forEach((item) => {
    const rect = item.getBoundingClientRect();
    if (rect.top < window.innerHeight - 20 && rect.bottom > 20) {
      item.classList.remove("--img-loading");
    }
  });
}
const initImageObserver = () => {
  removeLoadingClasses();
  window.addEventListener("scroll", removeLoadingClasses);
};
initImageObserver();
const allForms = document.querySelectorAll("form.custom-validation");
allForms.forEach((form) => {
  const inputObjs = Array.from(
    form.querySelectorAll("input:not([type=radio]), textarea, select")
  ).map((input) => {
    return {
      errorBox:
        input.parentElement.querySelector(".error-box") ||
        input.parentElement.parentElement.querySelector(".error-box"),
      input: input,
      type: input.type,
    };
  });
  const submitBtn = form.querySelector("button");
  inputObjs.forEach((obj) => {
    obj.input.addEventListener("input", () => {
      if (
        inputObjs.every(
          (obj_2) =>
            !obj_2.errorBox ||
            (obj_2.input.type !== "checkbox" && obj_2.input.value) ||
            obj_2.input.checked ||
            obj_2.input.dataset.ignore === "true"
        )
      ) {
        submitBtn.classList.add("--available");
      } else {
        submitBtn.classList.remove("--available");
      }
    });
  });
  submitBtn.addEventListener("click", (e) => {
    let hasErrors = false;
    inputObjs.forEach((obj) => {
      let inputError = false;
      if (obj.errorBox) {
        if (obj.errorBox.closest("[data-field-hide=true]")) return;
        switch (obj.type) {
          case "text":
          case "password":
          case "number":
            if (!obj.input.value) {
              inputError = true;
            }
            break;
          case "email":
            if (
              !obj.input.value ||
              !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(
                obj.input.value
              )
            ) {
              inputError = true;
            }
            break;
          case "checkbox":
            if (!obj.input.checked) {
              inputError = true;
            }
            break;
          default:
            break;
        }
        if (obj.input.tagName === "TEXTAREA" && !obj.input.value) {
          inputError = true;
        }
        if (
          obj.input.tagName === "SELECT" &&
          !obj.input.value &&
          obj.input.dataset.ignore !== "true"
        ) {
          inputError = true;
        }
        if (inputError) {
          if (obj.input.getAttribute("type") !== "checkbox") {
            obj.errorBox.innerText = obj.errorBox.dataset.value;
          }
          const parent = obj.errorBox.parentElement;
          const mainContainer = parent.classList.contains("centered-error")
            ? parent.parentElement
            : parent;
          mainContainer.classList.add("error-highlight");
          hasErrors = true;
        } else {
          obj.errorBox.innerText = "";
          const parent = obj.errorBox.parentElement;
          const mainContainer = parent.classList.contains("centered-error")
            ? parent.parentElement
            : parent;
          mainContainer.classList.remove("error-highlight");
        }
      }
    });
    if (hasErrors) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    const extraHiddenInputs = Array.from(
      document.querySelectorAll("[data-field-hide=true]")
    );
    extraHiddenInputs.forEach((inp) => {
      inp.parentElement.removeChild(inp);
    });
  });
});

function initNavigationAnimation() {
  const navItemsMap = Array.from(
    document.querySelectorAll(".nav-first-level > span")
  ).map((item) => {
    const subItems = Array.from(
      item.parentElement.querySelectorAll(".nav__dropdown li > span")
    );
    const data = {
      self: item,
      parent: item.parentElement,
      nav: item.parentElement.querySelector(".nav__dropdown"),
      subItems: !subItems.length
        ? null
        : subItems.map((subItem) => {
            const data = {
              self: subItem,
              parent: subItem.parentElement,
              nav: subItem.parentElement.querySelector(".nav__dropdown"),
              active: subItem.parentElement.classList.contains("is-active"),
            };
            if (data.active) {
              data.nav.style.height = `${data.nav.scrollHeight}px`;
            }
            return data;
          }),
      active: item.parentElement.classList.contains("is-active"),
    };
    if (data.active) {
      data.nav.style.height = `${data.nav.scrollHeight}px`;
    }
    return data;
  });
  function closeNavItem(item, parent) {
    if (item.subItems) {
      const activeSubItem = item.subItems.find((subItem) => subItem.active);
      if (activeSubItem) {
        activeSubItem.nav.style.height = "0px";
        activeSubItem.parent.classList.remove("is-active");
        activeSubItem.active = false;
      }
    }
    if (parent) {
      const height = parent.nav.scrollHeight - item.nav.scrollHeight;
      parent.nav.style.height = "".concat(height, "px");
    }
    item.nav.style.height = "0px";
    item.parent.classList.remove("is-active");
    item.active = false;
  }
  function openNavItem(item, arr, parent) {
    arr.forEach((sibling) => {
      if (sibling.active) closeNavItem(sibling);
    });
    const height = item.nav.scrollHeight;
    if (parent) {
      const parentHeight = parent.nav.scrollHeight;
      parent.nav.style.height = "".concat(height + parentHeight, "px");
    }
    item.nav.style.height = "".concat(height, "px");
    item.parent.classList.add("is-active");
    item.active = true;
  }
  navItemsMap.forEach((item, i, arr) => {
    var _item$subItems;
    item.self.addEventListener("click", () => {
      const isOpen = item.active;
      if (isOpen) {
        closeNavItem(item);
      } else {
        openNavItem(item, arr);
      }
    });
    (_item$subItems = item.subItems) === null || _item$subItems === void 0
      ? void 0
      : _item$subItems.forEach((subItem, j, subArr) => {
          subItem.self.addEventListener("click", () => {
            const isOpen = subItem.active;
            if (isOpen) {
              closeNavItem(subItem, item);
            } else {
              openNavItem(subItem, subArr, item);
            }
          });
        });
  });
}

initNavigationAnimation();

document.querySelectorAll(".js-currency-selector input").forEach((input) => {
  input.addEventListener("change", () => {
    input.closest("form").submit();
  });
});

document.querySelectorAll(".has-shipping-table").forEach((tableHolder) => {
  const tables = tableHolder.querySelectorAll("table");
  const activeCurr = Shopify.currency.active;
  const rate = Number(Shopify.currency.rate);
  if (activeCurr.toLowerCase() === "eur") return;
  tables.forEach((table) => {
    table.querySelectorAll("td:nth-child(3").forEach((td) => {
      let text = td.innerText.toLowerCase().split(" ");
      if (text.indexOf("eur") >= 0) {
        text = text.map((item) => {
          if (!isNaN(item)) {
            return Math.ceil(Number(item) * rate);
          } else if (item === "eur") {
            return activeCurr;
          } else {
            return item;
          }
        });
      }
      td.innerText = text.join(" ");
    });
  });
});

document.querySelectorAll(".has-price-text").forEach((priceText) => {
  const activeCurr = Shopify.currency.active;
  const rate = Number(Shopify.currency.rate);
  if (activeCurr.toLowerCase() === "eur") return;
  let i = 0;
  let text = priceText.innerHTML;
  while (i < text.length && text.toLowerCase().slice(i).indexOf("eur") >= 0) {
    const j = text.toLowerCase().slice(i).indexOf("eur") + i;
    if (j < 2) {
      i = 2;
      return;
    }
    let firstPart = text.slice(0, j - 1);
    let lastPart = text.slice(j);
    const lastSpaceIndex = firstPart.lastIndexOf(" ");
    let itemBefore = firstPart.slice(lastSpaceIndex + 1);
    if (!isNaN(itemBefore)) {
      const newRate = "".concat(Math.ceil(Number(itemBefore) * rate));
      firstPart = firstPart.slice(0, lastSpaceIndex + 1) + newRate;
      text = firstPart + " " + activeCurr + lastPart.slice(3);
      i = j + 3 + newRate.length - itemBefore.length;
    } else {
      i = j + 3;
    }
  }
  priceText.innerHTML = text;
});
const fixedFooter = document.querySelector(".js-fixed-footer");
if (fixedFooter) {
  let lastPos = null;
  let startTime = null;
  let timer = 0;
  let timeout = null;
  fixedFooter.addEventListener("mouseenter", () => {
    if (timeout) clearTimeout(timeout);
  });
  fixedFooter.addEventListener("mouseleave", () => {
    timeout = setTimeout(() => {
      fixedFooter.classList.remove("--active");
    }, 2000);
  });
  setInterval(() => {
    timer++;
  }, 50);
  window.addEventListener("scroll", (e) => {
    const dist = window.scrollY - lastPos;
    const diff = dist / (timer - startTime);
    if (isFinite(diff) && diff > 100 && window.innerWidth > 768) {
      fixedFooter.classList.add("--active");
      if (timeout) clearTimeout(timeout);
      timeout = setTimeout(() => {
        fixedFooter.classList.remove("--active");
      }, 2000);
    }
    lastPos = window.scrollY;
    startTime = timer;
  });
}
function setMainMinHeight() {
  const header = document.querySelector(".header-container");
  const main = document.querySelector("#MainContent");
  const footer = document.querySelector(".footer-primary");
  const minHeight = "calc(100vh - ".concat(
    header.offsetHeight +
      (footer
        ? Number(window.getComputedStyle(footer).paddingTop.replace("px", ""))
        : 0),
    "px)"
  );
  main.style.minHeight = minHeight;
}
0;
setMainMinHeight();
window.addEventListener("resize", setMainMinHeight);
